import React from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import './fielddatestyle.css';
import '../fieldstyle.css'

const FieldDate = ({ input, label, readOnly, placeholder, meta: { touched, error, invalid, warning } }) => (
    <div className={`grupo-form ${touched && invalid ? 'tiene-error' : ''}`}>
    <label className='label-control'>{label}</label>
    <div>
      <DayPickerInput {...input} className='control' placeholder={placeholder} format="DD/MM/YYYY" disabled={readOnly}/>
      <div className='descrip-error'>
      {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
      </div>
    </div>
  </div>
)
export default FieldDate